export default __webpack_public_path__ + "static/media/Group 12725.8a1c6b71.svg";